import Text from "components/typography/Text";
import pseudoFormat from "utils/pseudoFormat";

const VisitorsCount = ({ counter, withZero, color, ...rest }) => {
	return (
		<Text textNowrap {...rest}>
			<Text block mx={1}></Text>
			{counter > 0 || withZero ? (
				<Text color={color} block>
					{pseudoFormat(counter)}
				</Text>
			) : null}
		</Text>
	);
};

export default VisitorsCount;
